var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingPanel',{attrs:{"title":"Auto close ticket (By admin)","subheader":_vm.$t('auto_close_ticket_remark'),"loading":_vm.loading},scopedSlots:_vm._u([{key:"edit",fn:function(ref){
var done = ref.done;
return [_c('AdminAutoCloseTicketManagement',{attrs:{"value":_vm.config},on:{"submit":function($event){_vm.handleSubmit(function () { return done(); })},"close":function($event){return done()}}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5aa74f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/ticket3/ticket-management/Setting/AdminAutoCloseTicket.vue
// module id = null
// module chunks = 